export default __webpack_public_path__ + "static/media/ring.6b16b432.mp3";